import { useCallback } from "react";

export default function useCanvasPrint({ canvasWrapperPrintTargetClassName }) {
  const printCanvas = useCallback(async () => {
    const originalContent = document.body.innerHTML;
    const printContent = document.querySelector(
      `.${canvasWrapperPrintTargetClassName}`,
    )?.innerHTML;

    if (!printContent) return;

    document.body.innerHTML = printContent;
    window.print();

    setTimeout(() => {
      document.body.innerHTML = originalContent;
      window.location.reload();
    }, 2000);
  }, [canvasWrapperPrintTargetClassName]);

  return { printCanvas };
}
